module.exports = __webpack_public_path__ + "static/img/img_5.6d35b26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_5.png
// module id = Vykv
// module chunks = 0